﻿/**
 * Cart Bundle Handler
 * Updates bundle titles and images in cart
 */

(function() {
  'use strict';

  class CartBundleHandler {
    constructor() {
      this.init();
    }

    init() {
      // Listen for cart updates
      document.addEventListener('on:cart:after-merge', () => {
        setTimeout(() => this.detectAndRenderBundles(), 500);
      });

      // Listen for cart drawer after open
      document.addEventListener('on:cart-drawer:after-open', () => {
        setTimeout(() => this.detectAndRenderBundles(), 200);
      });

      // Check on page load
      setTimeout(() => {
        this.detectAndRenderBundles();
      }, 1000);
    }

    async detectAndRenderBundles() {
      try {
        await new Promise(resolve => setTimeout(resolve, 200));
        
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Find cart items
        let itemWrappers = document.querySelectorAll('[data-cart-item-wrapper]');
        
        if (itemWrappers.length === 0) {
          itemWrappers = document.querySelectorAll('.items > .item');
        }
        
        if (itemWrappers.length === 0) {
          itemWrappers = document.querySelectorAll('[data-line-item], .cart-item, .line-item');
        }
        
        if (itemWrappers.length === 0) {
          return;
        }
        
        itemWrappers.forEach((wrapper, index) => {
          const item = cart.items[index];
          if (!item) return;

          const isBundled = item.properties && (
            item.properties._isBundled === true ||
            item.properties.__bundle ||
            item.properties.__bundleSignature
          );

          if (isBundled && item.properties.__bundle) {
            this.renderBundleItem(wrapper, item);
          }
        });
      } catch (error) {
        console.error('[Bundle Handler] Error:', error);
      }
    }

    renderBundleItem(wrapper, item) {
      const bundleData = item.properties.__bundle;
      let bundle;
      
      try {
        bundle = typeof bundleData === 'string' ? JSON.parse(bundleData) : bundleData;
      } catch (error) {
        console.error('Error parsing bundle data:', error);
        return;
      }

      // Create custom title
      const configId = item.properties._configId || 
                       item.properties.configuratorId || 
                       item.properties['Configuration ID'] || 
                       item.properties._mimeeqConfigId ||
                       item.variant_id || 
                       item.key || 
                       item.id || 
                       'NEW';
      
      const customTitle = `Single Exterior Door Builder – Ref#${configId}`;
      
      // Update the title
      const titleElement = wrapper.querySelector('.title a, .title');
      if (titleElement) {
        titleElement.textContent = customTitle;
      }
      
      // Update image with configurator hero image
      const image = bundle.image || item.image;
      if (image) {
        const imgElement = wrapper.querySelector('.item-image img, img');
        if (imgElement) {
          imgElement.src = image;
          imgElement.alt = customTitle;
        }
      }
    }
  }

  // Initialize
  if (typeof window !== 'undefined') {
    window.cartBundleHandler = new CartBundleHandler();
    window.mimeeqBundleHandler = window.cartBundleHandler;
  }
})();

